import {ApplicationActions} from "./application-actions"
import {KundeActions} from "./kunde-actions"
import {AnbahnungActions} from "./anbahnung-actions"
import {TarifierungActions} from "./tarifierung-actions"
import {VersicherungsumfangActions} from "./versicherungsumfang-actions"
import {RisikoortActions} from "./risikoort-actions"
import {BereicheActions} from "./bereiche-actions"
import {KalkulationActions} from "./kalkulation-actions"
import {BetriebsunterbrechungActions} from "./betriebsunterbrechung-actions"
import {ProduktfinderActions} from "./produktfinder-actions"
import {DruckcenterActions} from "./druckcenter-actions"
import {GruppenunfallActions} from "./gruppenunfall-actions"
import {PhotovoltaikActions} from "./photovoltaik-actions"

export const UwpActions = (actionProps) => ({
    ...ApplicationActions(actionProps),
    ...KundeActions(actionProps),
    ...AnbahnungActions(actionProps),
    ...TarifierungActions(actionProps),
    ...VersicherungsumfangActions(actionProps),
    ...RisikoortActions(actionProps),
    ...BereicheActions(actionProps),
    ...KalkulationActions(actionProps),
    ...BetriebsunterbrechungActions(actionProps),
    ...ProduktfinderActions(actionProps),
    ...DruckcenterActions(actionProps),
    ...GruppenunfallActions(actionProps),
    ...PhotovoltaikActions(actionProps),
})
